/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

var checkboxDefaultProps = {
  checkAll: false,
  defaultChecked: false,
  disabled: void 0,
  indeterminate: false,
  readonly: false
};
var checkboxGroupDefaultProps = {
  max: void 0,
  defaultValue: []
};

export { checkboxDefaultProps, checkboxGroupDefaultProps };
//# sourceMappingURL=defaultProps.js.map
